import React from 'react';
import EtherscanLogo from './../../images/etherscan.png';

export default class EtherscanLink extends React.PureComponent {
  render () {
    return (
      <a href={'https://ropsten.etherscan.io/tx/' + this.props.txHash}
         className="c-etherscan-link" target="_blank">
        <img role="presentation" src={EtherscanLogo}/>
      </a>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Components/EtherscanLink.js